export default __webpack_public_path__ + "static/media/youtube-blue.95951a3a.svg";